import axios  from 'axios'
import { verificarTokenAutenticacao } from '../../middleware/Token'

const BASEAPIPROJETOS = axios.create ({
    baseURL: process.env.REACT_APP_API_PROJETOS_GESTTOR,
    headers: {
        'Content-Type': 'multipart/form-data',
    }

})

BASEAPIPROJETOS.interceptors.request.use (async config => {
    const token = verificarTokenAutenticacao ()

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

export default  BASEAPIPROJETOS